import React from 'react';
import AsyncSelect from 'react-select/async';
import { Field, Label, Control } from 'rbx';
import gql from 'graphql-tag';
import client from '../../../utils/apolloClient';

const searchApiActionsQuery = gql`
  query searchApiActionsQuery($input: SearchInput) {
    search_cms_roles(input: $input) {
      roles {
        name
      }
    }
  }
`;

const promiseOptions = value =>
  new Promise(resolve => {
    client.clientPrivate
      .query({
        query: searchApiActionsQuery,
        variables: {
          input: {
            filter: {
              cms_role_filter: { status: 'ACTIVE', name: value },
            },
          },
        },
        fetchPolicy: 'network-only',
      })
      .then(({ data }) => {
        if (data) {
          resolve(
            data.search_cms_roles.roles.map(item => ({
              label: item.name,
              value: item.name,
            })),
          );
        }
      })
      .catch(error => {
        console.log('error', error);
      });
  });

const customStyles = {
  container: provided => ({
    ...provided,
  }),
  control: provided => ({
    ...provided,
    borderRadius: '3px',
    minHeight: '1px',
    // height: '29px',
    fontSize: '0.8rem',
  }),
  input: provided => ({
    ...provided,
    minHeight: '1px',
  }),
  dropdownIndicator: provided => ({
    ...provided,
    minHeight: '1px',
    paddingTop: '0',
    paddingBottom: '0',
    color: '#757575',
  }),
  indicatorSeparator: provided => ({
    ...provided,
    minHeight: '1px',
    height: '11px',
  }),
  clearIndicator: provided => ({
    ...provided,
    minHeight: '1px',
  }),
  valueContainer: provided => ({
    ...provided,
    minHeight: '1px',
    // height: '27px',
    paddingTop: '0',
    paddingBottom: '0',
  }),
  singleValue: provided => ({
    ...provided,
    minHeight: '1px',
    paddingBottom: '2px',
  }),
  option: provided => ({
    ...provided,
    fontSize: '0.8rem',
  }),
};

const AssignRoleTypeInput = ({
  label,
  required,
  value,
  onChange,
  isDisabled,
}) => (
  <Field>
    <Label className="is-flex">
      {label}
      {required && <span className="has-text-danger">*</span>}
    </Label>
    <Control>
      <AsyncSelect
        value={value}
        cacheOptions
        styles={customStyles}
        loadOptions={promiseOptions}
        defaultOptions
        onChange={onChange}
        isDisabled={isDisabled}
        closeMenuOnSelect={false}
        isMulti
      />
    </Control>
  </Field>
);

export default AssignRoleTypeInput;
